import { genericGet } from "../../../utils/genericApiCall";

export async function obtenerCondicionLaboral() {
    const url_endpoint = '/CondicionLaboral/ListarTodos';
    const message_info = 'Obteniendo Condiciones Laborales...';
    const message_error = 'Error al obtener datos de condiciones laborales...';

    return await genericGet({
        url_endpoint: url_endpoint, 
        message_info: message_info, 
        message_error: message_error
    });

}